/* GrowLabs LP – ELANI – nicht in andere Templates einbinden.
   Umfang-Toggle (Set oder Einzeln → Featured-Product-Sections), Preis-Sync (Sticky/Final-CTA), Sticky-Bar.
   Je Umfang genau eine Variante; Warenkorb läuft über das Formular der sichtbaren Featured-Product-Section. */
(() => {
  const box = document.querySelector('[data-lp-picker]');
  if (!box) return;

  const data = {};
  box.querySelectorAll('[data-lp-variants]').forEach((el) => {
    try { data[el.dataset.lpVariants] = JSON.parse(el.textContent); } catch (e) { /* defektes JSON → Scope ohne Sync */ }
  });
  // Formulare der Featured-Product-Sections: id="product-form-<section>-<product.id>"
  const forms = {};
  Object.keys(data).forEach((k) => {
    const f = document.querySelector(`form[id^="product-form-"][id$="-${data[k].product}"]`);
    if (f) forms[k] = f;
  });
  const buybox = () => forms[scope] && forms[scope].closest('.shopify-section');

  let scope = box.dataset.activeScope;

  const current = (s) => data[s];

  // Produktbild + Titel des aktiven Umfangs für Sticky-Bar und Final-CTA
  function renderMedia() {
    const v = data[scope];
    if (!v) return;
    if (v.image) {
      document.querySelectorAll('[data-lp-sticky-img]').forEach((img) => {
        img.src = v.image;
        img.hidden = false;
      });
      document.querySelectorAll('.lp-final__media img').forEach((img) => {
        img.src = v.image_lg;
        img.removeAttribute('srcset');
      });
    }
    if (v.label) document.querySelectorAll('[data-lp-final-title]').forEach((el) => { el.textContent = v.label; });
  }
  function renderPrices() {
    const v = current(scope);
    if (!v) return;
    renderMedia();
    document.querySelectorAll('[data-lp-price-active]').forEach((el) => { el.innerHTML = v.html; });
    document.querySelectorAll('[data-lp-short-price]').forEach((el) => {
      el.innerHTML = `<strong>${v.price}</strong>${v.compare ? ` <s>${v.compare}</s>` : ''}`;
    });
    document.querySelectorAll('[data-lp-submit][data-label]').forEach((el) => {
      el.textContent = el.dataset.label.replace('{price}', v.price);
    });
  }

  function setScope(next, scroll) {
    if (!forms[next] || next === scope && document.documentElement.dataset.lpScope) return;
    scope = next;
    document.documentElement.dataset.lpScope = next;
    document.querySelectorAll('[data-lp-scope]').forEach((el) => { el.hidden = el.dataset.lpScope !== next; });
    box.querySelectorAll('[data-lp-scope-btn]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.lpScopeBtn === next)));
    // Galerie der eben eingeblendeten Section neu vermessen (Flickity war bei display:none 0 px breit)
    window.dispatchEvent(new Event('resize'));
    renderPrices();
    if (scroll) buybox().scrollIntoView({ behavior: 'smooth' });
    document.dispatchEvent(new CustomEvent('lp:scope', { detail: { scope: next } }));
  }

  box.querySelectorAll('[data-lp-scope-btn]').forEach((b) => b.addEventListener('click', () => setScope(b.dataset.lpScopeBtn, true)));

  // Demo-Scroller: Fortschrittslinie + Pfeil (am Ende zurück zum Anfang)
  document.querySelectorAll('[data-lp-scroller]').forEach((sc) => {
    const track = sc.querySelector('[data-lp-track]');
    const bar = sc.querySelector('[data-lp-progress]');
    const btn = sc.querySelector('[data-lp-next]');
    if (!track) return;
    const update = () => {
      const max = track.scrollWidth - track.clientWidth;
      if (bar) bar.style.width = `${Math.max(12, Math.min(100, ((track.scrollLeft + track.clientWidth) / track.scrollWidth) * 100))}%`;
      const wrap = sc.querySelector('.lp-demo__bar');
      if (wrap) wrap.hidden = max < 4;
    };
    track.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
    window.addEventListener('resize', update);
    if (btn) btn.addEventListener('click', () => {
      const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      track.scrollTo({ left: atEnd ? 0 : track.scrollLeft + track.clientWidth * 0.8, behavior: 'smooth' });
    });
    update();
  });

  // Echte Anwendung: Play-Button startet stumm, danach native Controls
  document.querySelectorAll('[data-lp-ugc-play]').forEach((btn) => btn.addEventListener('click', () => {
    const v = btn.previousElementSibling;
    v.controls = true;
    v.play();
    btn.hidden = true;
  }));

  // Sticky-Bar / Final-CTA → sichtbares Buy-Box-Formular abschicken
  document.querySelectorAll('[data-lp-submit]').forEach((btn) => btn.addEventListener('click', () => {
    const form = forms[scope];
    const cta = form && form.querySelector('[data-product-add-to-cart-button]');
    if (!form || !cta || cta.disabled) return buybox().scrollIntoView({ behavior: 'smooth' });
    form.requestSubmit(cta);
  }));

  document.querySelectorAll('[data-lp-scroll-buybox]').forEach((btn) => btn.addEventListener('click', () => {
    buybox().scrollIntoView({ behavior: 'smooth' });
  }));

  // Sticky-Bar: sichtbar, wenn der aktive Buy-Box-CTA oben aus dem Viewport ist und der Final-CTA nicht im Bild steht.
  // Live gemessen (scroll/resize) statt IntersectionObserver – der meldet bei Sprüngen (z. B. „nach oben“) nichts.
  const sticky = document.querySelector('[data-lp-sticky]');
  if (sticky) {
    const final = document.querySelector('[data-lp-final]');
    let ticking = false;
    const update = () => {
      ticking = false;
      const cta = forms[scope] && forms[scope].querySelector('[data-product-add-to-cart-button]');
      const passed = cta ? cta.getBoundingClientRect().bottom <= 0 : false;
      const fr = final && final.getBoundingClientRect();
      const finalIn = !!fr && fr.top < window.innerHeight && fr.bottom > 0;
      const show = passed && !finalIn;
      sticky.hidden = !show;
      document.documentElement.classList.toggle('lp-has-sticky', show);
    };
    const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    document.addEventListener('lp:scope', onScroll);
    update();
  }

  const fromUrl = new URLSearchParams(location.search).get('scope');
  setScope(forms[fromUrl] ? fromUrl : scope);
})();
